export default __webpack_public_path__ + "static/media/47.5a0dfbed.jpg";